import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=be4af9fa&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be4af9fa')) {
      api.createRecord('be4af9fa', component.options)
    } else {
      api.reload('be4af9fa', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=be4af9fa&", function () {
      api.rerender('be4af9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-277F3nLZsnLHu/JS/videoIframe.vue"
export default component.exports